export const getLocationFromLatLngStrings = ({
  lat,
  lng,
}: {
  lat: string
  lng: string
}): { latitude: number; longitude: number } => {
  return {
    latitude: parseFloat(lat),
    longitude: parseFloat(lng),
  }
}
